__turbopack_context__.v({
  "btn": "CookiePopupNew-module-scss-module__gWZ9IW__btn",
  "close": "CookiePopupNew-module-scss-module__gWZ9IW__close",
  "column": "CookiePopupNew-module-scss-module__gWZ9IW__column",
  "container": "CookiePopupNew-module-scss-module__gWZ9IW__container",
  "more": "CookiePopupNew-module-scss-module__gWZ9IW__more",
  "show": "CookiePopupNew-module-scss-module__gWZ9IW__show",
  "text": "CookiePopupNew-module-scss-module__gWZ9IW__text",
});
